// https://hips.hedera.com/hip/hip-15
const accountIdRegex = /^(0|(?:[1-9]\d*))\.(0|(?:[1-9]\d*))\.(0|(?:[1-9]\d*))(?:-([a-z]{5}))?$/

export function isValidHederaAddress(address: string): boolean {
  return accountIdRegex.test(address)
}
